class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.form = this.querySelector('form.search');
    this.input = this.querySelector('input[data-predictive-search-input]');
    this.viewInput = this.querySelector('input[data-view-input]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.isOpen = false;

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
  }

  setupEventListenersOnDynamicElements() {
    this.viewAllButtons = this.querySelectorAll('[data-view-all]');
    for (const viewAllButton of this.viewAllButtons) {
      viewAllButton.addEventListener('click', this.onViewAllButtonClick.bind(this));
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();
    if (!searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onViewAllButtonClick(event) {
    event.preventDefault();
    const view = event.currentTarget.getAttribute('data-view');
    this.viewInput.value = view;
    this.form.submit();
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) event.preventDefault();
    document.body.classList.add('search-active');
    this.closest('.search-wrap').classList.add('active');
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    if (this.cachedResults[queryKey]) {
      this.cachedResults[queryKey].trim() === '' ? this.predictiveSearchResults.classList.add('empty') : this.predictiveSearchResults.classList.remove('empty');
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,page,collection&${encodeURIComponent('resources[fields]')}=tag&${encodeURIComponent('resources[limit]')}=10&${encodeURIComponent('resources[limit_scope]')}=each&section_id=predictive-search-new`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search-new').innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        resultsMarkup.trim() === '' ? this.predictiveSearchResults.classList.add('empty') : this.predictiveSearchResults.classList.remove('empty');
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setupEventListenersOnDynamicElements();
    this.open();
  }

  open() {
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);

    this.isOpen = false;
  }
}

customElements.define('predictive-search', PredictiveSearch);
